import NavBar from './navbar';

const LoadCases = () => {
	return (
		<div>
			<NavBar />
			<div className="centered" style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ fontFamily: 'kanitbold' }}>LOADING CASES</div>
				<img src={require('../assets/bricks.gif')} alt='Bricks-Gif' style={{ width: 67, height: 34 }} />
			</div>
		</div>
	);
}

export default LoadCases;